import intl from 'react-intl-universal';
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ExchangeGoodType, OldGoodType } from '@/type/components';
import { Col, Row } from 'antd';
import { default as Button } from '@/components/CssBtn';

import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import AddGoodItem from '../AddGoodItem';
import styles from './index.less';

type RefundGoodProps = {
    value?: OldGoodType[];
    onChange?: (value: OldGoodType[]) => void;
    disable?: boolean;
    readonly?: boolean;
    orderCreatedTime?: string;
    sessionId?: string;
};

const RefundGood: React.FC<RefundGoodProps> = ({
    value,
    onChange,
    readonly = false,
    orderCreatedTime = '',
    sessionId,
}) => {
    const [goods, setGoods] = useState<ExchangeGoodType[]>(() => {
        return value?.map((item) => ({ oldGoods: item })) || [{}];
    });

    const canAdd = useMemo(() => {
        return goods.every((item) => item.oldGoods !== undefined);
    }, [goods]);

    useEffect(() => {
        if (goods.length === 0) {
            setGoods([{}]);
        }
        onChange &&
            onChange(
                goods
                    .filter((item) => item.oldGoods !== undefined)
                    .map((item) => item.oldGoods || {}),
            );
    }, [goods]);

    return (
        <div className={styles.container}>
            {goods.map((item, index) => {
                return (
                    <Row
                        key={JSON.stringify(item)}
                        className={styles.item}
                        wrap={false}
                    >
                        <Col flex={1}>
                            <AddGoodItem
                                aftersaleType={100}
                                index={index + 1}
                                value={item}
                                orderCreatedTime={orderCreatedTime}
                                mode={1}
                                onChange={(exchangeGood) => {
                                    const copyGoods = [...goods];
                                    copyGoods.splice(index, 1, exchangeGood);
                                    setGoods(copyGoods);
                                }}
                                disable={readonly}
                                sessionId={sessionId}
                            />
                        </Col>
                        <Col>
                            <Button
                                type="link"
                                danger
                                onClick={() => {
                                    const copyGoods = [...goods];
                                    copyGoods.splice(index, 1);
                                    setGoods(copyGoods);
                                }}
                                style={{
                                    visibility: readonly ? 'hidden' : 'visible',
                                }}
                            >
                                {intl.get('删除')}
                            </Button>
                        </Col>
                    </Row>
                );
            })}
            <Button
                onClick={() => setGoods([...goods, {}])}
                disabled={!canAdd}
                style={readonly ? { display: 'none' } : {}}
            >
                {intl.get('添加商品')}
            </Button>
        </div>
    );
};

export default RefundGood;
